<template>
    <chats-store
        v-slot="{
            sid,
            error,
            is_loading: is_saving,
            has_loaded,
            store
        }"
        @success="onSuccess"
    >
        <base-form @submit="store(data)">
            <button
                :disabled="is_saving || has_loaded || personas.length < 1"
                class="block btn btn-sm btn-with-icon id-chats-store-button"
                :class="{
                    'opacity-50': personas.length < 1
                }"
            >
                <div class="flex items-center justify-center">
                    <base-svg
                        :name="is_saving || has_loaded ? 'icon-loading' : 'icon-chat'"
                        :key="is_saving || has_loaded ? 'icon-loading' : 'icon-chat'"
                        class="w-6 h-6 md:mr-2"
                    />
                    <div class="hidden md:block">
                        <slot />
                    </div>
                </div>
            </button>
        </base-form>
    </chats-store>
</template>

<script>
    import ChatsStore from './chats-store'

    export default {
        components: {
            ChatsStore
        },
        props: {
            personas: {
                type: Array,
                required: true
            }
        },
        computed: {
            data () {
                return {
                    personas: this.personas.map(({ object, uuid }) => {
                        return {
                            object,
                            uuid
                        }
                    })
                }
            }
        },
        methods: {
            onSuccess ({ data: chat }) {
                this.$router.push({
                    name: this.$router.fix('dashboard.*.chats.show'),
                    params: {
                        chat: chat.uuid
                    }
                })
            }
        }
    }
</script>
